

.label {
  display: flex;
  gap: 0.5rem;
}

